import { Control, Controller } from "react-hook-form";

import { FormLabel } from "@ui/FormElements";
import { ICreateDealForm, SourceCompanySelect } from "@components/AddNewEntity/Deal";
import { useCompanyAndSuggestionOptions } from "@components/AddNewEntity/hooks/useCompanyAndSuggestionOptions";

interface ISourceCompanyFormFieldProps {
  control: Control<ICreateDealForm>;
}

export function SourceCompanyFormField({ control }: ISourceCompanyFormFieldProps) {
  const { groupedOptions, hasNextPage, debouncedSearch, isLoading, isFetchingNextPage, fetchNextPage } =
    useCompanyAndSuggestionOptions();

  return (
    <Controller
      control={control}
      name="source_company"
      render={({ field: { value, onChange } }) => (
        <div>
          <FormLabel htmlFor="type">Source Company</FormLabel>
          <SourceCompanySelect
            value={value}
            onValueChange={(value) => onChange(value)}
            placeholder="Select company"
            options={groupedOptions}
            hasNextPage={hasNextPage}
            debouncedSearch={debouncedSearch}
            isLoading={isLoading}
            isFetchingNextPage={isFetchingNextPage}
            fetchNextPage={fetchNextPage}
          />
        </div>
      )}
    />
  );
}
